<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <div>
    <div class="card card-primary">
      <div class="card-header">
        <h3 class="card-title">Adicionar arquivo lote</h3>
      </div>
      <div class="card-body">
        <br />
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <div class="input-group">
                <div class="custom-file">
                  <input
                    id="file_select"
                    class="form-control"
                    type="file"
                    @change="onChange"
                    multiple="multiple"
                    style="height: 80px; margin-bottom: 25px"
                  />
                </div>
              </div>
            </div>

            <div v-if="erros.length" style="line-height: 17px; margin-bottom: 5px">
              <span style="color: red" v-for="error in erros" :key="error">
                * {{ error }}
                <br />
              </span>
            </div>

            <button @click="importar()" class="btn btn-info">Enviar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert.js";
import currencyController from "../../controller/currencyController.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["estados", "cidades", "leilao"],

  mixins: [sweetAlert, Swal, AuxController, currencyController],

  components: { Loading },

  data() {
    return {
      isLoading: false,
      documento_selecionado: "",
      filtro: "",
      paginas: [],
      lotes_extraidos_excel: [],
      categorias: [],
      lotes: [],
      erros: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      nome: "",
      estado: "",
      cidade: "",
      cpf_cnpj: "",
      endereco: "",
      email: "",
      fone: "",
      nome_contato: "",
      arquivos_leilao: "",
      arquivo_lotes_excel: "",
      lote_selecionado: "",
    };
  },

  mounted() {
    console.log("Cidades");
    console.log(this.cidades);
  },

  methods: {
    async importar() {
      if (this.arquivo_lotes_excel) {
        const reader = new FileReader();

        this.lotes_extraidos_excel = [];
        this.erros = [];

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

          data.shift();

          console.log("Data");
          console.log(data);

          let start_index = -1;

          for (let i = 0; i < data.length; i++) {
            if (data[i].length && data.length >= 5) {
              if (data[i][0] == "LOTE" && data[i][1] == "UF_ID" && data[i][2] == "CIDADE_ID") {
                start_index = i;
              }
            }
          }

          console.log("Start index " + (start_index + 1));

          if (start_index < 0) {
            this.showErrorMessageWithButton("Ops...", "O arquivo não está no formato correto.");
            this.erros.push("O arquivo não está no formato correto.");
          } else if (start_index >= data.length) {
            this.showErrorMessageWithButton("Ops...", "O arquivo não possui dados.");
            this.erros.push("O arquivo não possui dados.");
          } else {
            //SUBTRAINDO INICIO
            let indice_linha = 11 - (start_index + 1);

            //INICIALIZANDO OS LOTES
            //I = 9 PARA PULAR LINHAS DE EXPLICAÇÃO
            for (let i = start_index + 1; i < data.length; i++) {
              //VERIFICAR LINHAS EM BRANCO
              if (data[i].length == 0) {
                //this.showErrorMessageWithButton("Ops...", "O arquivo possui linhas em branco, favor remover antes de continuar.");
              } else {
                this.lotes_extraidos_excel.push({
                  linha: i + indice_linha,
                  lote_numero: data[i][0],
                  estado: data[i][1],
                  cidade: data[i][2],
                  processo_id: data[i][3],
                  categoria_id: data[i][4],
                  lote_tipo: data[i][5],
                  avaliacao: data[i][6],
                  valor_primeira_praca: data[i][7],
                  valor_segunda_praca: data[i][8] ?? 0 ,
                  titulo: data[i][9],
                  descricao: data[i][10],
                  incrementos: data[i][11],
                  comissao: data[i][12],
                  icms: data[i][13],
                  parcelado: data[i][14],
                  bloquear_pf: data[i][15],
                  sucata: data[i][16],
                });
              }
            }

            if (this.lotes_extraidos_excel.length == 0) {
              this.showErrorMessageWithButton("Ops...", "O arquivo não possui dados.");
              this.erros.push("O arquivo não possui dados.");
            }
          }
        };

        //VERIFICANDO PROCESSO
        if (this.leilao.leilao_tipo == "judicial") {
          for (let i = 0; i < this.lotes_extraidos_excel.length; i++) {
            if (!this.lotes_extraidos_excel[i].processo_id) {
              this.lotes_extraidos_excel[i].processo_id = this.leilao.processo_id;
            }
          }
        }

        console.log(this.lotes_extraidos_excel);

        reader.readAsBinaryString(this.arquivo_lotes_excel);

        try {
          //VALIDANDO LOTE_NUMERO
          let response = await this.buscarLotes();
          this.lotes = response.data.lotes;

          for (let i = 0; i < this.lotes_extraidos_excel.length; i++) {
            let indice = this.findLoteByLoteNumero(this.lotes_extraidos_excel[i].lote_numero);

            if (indice >= 0) {
              this.logError("Lote " + this.lotes_extraidos_excel[i].lote_numero + " já existe no banco.");
            }
          }

          //VALIDANDO CAMPOS OBRIGATÓRIOS
          if (!this.erros.length) {
            for (let i = 0; i < this.lotes_extraidos_excel.length; i++) {
              if (!this.lotes_extraidos_excel[i].lote_numero) {
                this.logError('O campo "Lote" é obrigatório (lote nº ' + this.lotes_extraidos_excel[i].lote_numero + "). ");
              }
              if (!this.lotes_extraidos_excel[i].categoria_id) {
                this.logError('O campo "Categoria" é obrigatório (lote nº ' + this.lotes_extraidos_excel[i].lote_numero + "). ");
              }
              if (!this.lotes_extraidos_excel[i].titulo) {
                this.logError('O campo "Título" é obrigatório (lote nº ' + this.lotes_extraidos_excel[i].lote_numero + "). ");
              }
              if (!this.lotes_extraidos_excel[i].descricao) {
                this.logError('O campo "Descricao" é obrigatório (lote nº ' + this.lotes_extraidos_excel[i].lote_numero + "). ");
              }
              if (!this.lotes_extraidos_excel[i].incrementos) {
                this.logError('O campo "Incrementos" é obrigatório (lote nº ' + this.lotes_extraidos_excel[i].lote_numero + "). ");
              }
              if (!this.lotes_extraidos_excel[i].comissao) {
                this.logError('O campo "Comissao" é obrigatório (lote nº ' + this.lotes_extraidos_excel[i].lote_numero + "). ");
              }
              if (!this.lotes_extraidos_excel[i].icms && this.lotes_extraidos_excel[i].icms != 0) {
                this.logError('O campo "Icms" é obrigatório (lote nº ' + this.lotes_extraidos_excel[i].lote_numero + "). ");
              }
              if (!this.lotes_extraidos_excel[i].parcelado && this.lotes_extraidos_excel[i].parcelado != 0) {
                this.logError('O campo "Parcelado" é obrigatório (lote nº ' + this.lotes_extraidos_excel[i].lote_numero + "). ");
              }
              if (!this.lotes_extraidos_excel[i].bloquear_pf && this.lotes_extraidos_excel[i].bloquear_pf != 0) {
                this.logError('O campo "Bloquear_pf" é obrigatório (lote nº ' + this.lotes_extraidos_excel[i].lote_numero + "). ");
              }
              if (!this.lotes_extraidos_excel[i].sucata && this.lotes_extraidos_excel[i].sucata != 0) {
                this.logError('O campo "Sucata" é obrigatório (lote nº ' + this.lotes_extraidos_excel[i].lote_numero + "). ");
              }
            }
          }

          //VALIDANDO CATEGORIA
          if (!this.erros.length) {
            response = await this.buscarCategorias();
            this.categorias = response.data.categorias;

            for (let i = 0; i < this.lotes_extraidos_excel.length; i++) {
              if (this.lotes_extraidos_excel[i].categoria_id) {
                let indice = this.categorias.findIndex((element) => element["id"] == this.lotes_extraidos_excel[i].categoria_id);

                if (indice < 0) {
                  this.logError(
                    "A categoria " +
                      this.lotes_extraidos_excel[i].categoria_id +
                      " não existe no banco  (lote nº " +
                      this.lotes_extraidos_excel[i].lote_numero +
                      ")."
                  );
                }
              } else {
                this.logError("O campo categoria é obrigatório (lote nº " + this.lotes_extraidos_excel[i].lote_numero + ").");
              }
            }
          }

          //VALIDANDO CIDADE E ESTADO
          if (!this.erros.length) {
            for (let i = 0; i < this.lotes_extraidos_excel.length; i++) {
              if (this.lotes_extraidos_excel[i].cidade) {
                console.log("VALIDANDO CIDADE AGORA");
                console.log(this.lotes_extraidos_excel[i].cidade);

                //CASO O ESTADO ESTEJA EM BRANCO
                if (!this.lotes_extraidos_excel[i].estado) {
                  this.logError(
                    "Campo estado não pode estar em branco caso cidade esteja preenchida (lote nº " + this.lotes_extraidos_excel[i].lote_numero + ")."
                  );
                } else {
                  //VALIDANDO NOME DA CIDADE
                  let indice_cidade = this.cidades.findIndex(
                    (element) => element["nome"].toUpperCase() == this.lotes_extraidos_excel[i].cidade.toUpperCase()
                  );

                  if (indice_cidade < 0) {
                    this.logError(
                      "A cidade " + this.lotes_extraidos_excel[i].cidade + " não existe (lote nº " + this.lotes_extraidos_excel[i].lote_numero + ")."
                    );
                  } else {
                    //ATRIBUINDO ID CIDADE
                    this.lotes_extraidos_excel[i].cidade_id = this.cidades[indice_cidade].id;

                    //VALIDANDO NOME DO ESTADO
                    let indice_estado = this.estados.findIndex(
                      (element) => element["sigla"].toUpperCase() == this.lotes_extraidos_excel[i].estado.toUpperCase()
                    );

                    if (indice_estado < 0) {
                      this.logError(
                        "O estado " +
                          this.lotes_extraidos_excel[i].estado +
                          " não existe (lote nº " +
                          this.lotes_extraidos_excel[i].lote_numero +
                          ")."
                      );
                    } else {
                      //VALIDANDO SE A CIDADE PERTENCE AO ESTADO
                      if (this.estados[indice_estado].id != this.cidades[indice_cidade].estado_id) {
                        this.logError(
                          "A cidade " +
                            this.lotes_extraidos_excel[i].cidade +
                            " não percente ao estado " +
                            this.lotes_extraidos_excel[i].estado +
                            " (lote nº " +
                            this.lotes_extraidos_excel[i].lote_numero +
                            ")."
                        );
                      } else {
                        //ATRIBUINDO ID ESTADO
                        this.lotes_extraidos_excel[i].estado_id = this.estados[indice_estado].id;
                      }
                    }
                  }
                }
              }
            }
          }

          //VALIDANDO SOMENTE ESTADO
          if (!this.erros.length) {
            for (let i = 0; i < this.lotes_extraidos_excel.length; i++) {
              if (this.lotes_extraidos_excel[i].estado) {
                //CASO O ESTADO ESTEJA EM BRANCO
                if (!this.lotes_extraidos_excel[i].cidade) {
                  this.logError(
                    "Campo cidade não pode estar em branco caso o estado esteja preenchido (lote nº " +
                      this.lotes_extraidos_excel[i].lote_numero +
                      ")."
                  );
                }
              }
            }
          }

          //VALIDANDO TIPO LOTE
          if (!this.erros.length) {
            for (let i = 0; i < this.lotes_extraidos_excel.length; i++) {
              if (this.lotes_extraidos_excel[i].lote_tipo) {
                //CASO O ESTADO ESTEJA EM BRANCO
                if (this.lotes_extraidos_excel[i].lote_tipo != "imovel" && this.lotes_extraidos_excel[i].lote_tipo != "movel") {
                  this.logError('O tipo do lote deve ser "movel" ou "imovel" (lote nº ' + this.lotes_extraidos_excel[i].lote_numero + ").");
                }
              }
            }
          }

          if (!this.erros.length) {
            this.isLoading = true;

            let data = {
              lotes: this.lotes_extraidos_excel,
              leilao_id: this.leilao.id,
            };

            console.log("Importando");
            console.log(data);

            axios
              .post(`/admin/lotes/import`, data)
              .then((response) => {
                this.isLoading = false;

                if (response.data.success) {
                  this.showSuccessMessageWithButtonAndRedirect(
                    "Sucesso",
                    this.lotes_extraidos_excel.length + " lotes importados com sucesso.",
                    "/admin/leilao/" + this.leilao.id + "/lotes"
                  );
                } else {
                  this.showErrorMessageWithButton("Ops..", "Houve um problema com a sua solicitação. Verifique o documento e tente novamente.");
                }
              })
              .catch((error) => {
                this.isLoading = false;
                console.log(error);

                if (typeof error == "object") {
                  if (error.response.status == "403") {
                    this.showErrorMessageWithButtonAndReload("Ops...", "Você precisa estar logado para importar lotes.");
                  } else {
                    this.showErrorMessageWithButton("Ops..", "Houve um problema com a sua solicitação. Verifique o documento e tente novamente.");
                  }
                } else {
                  this.showErrorMessageWithButtonAndReloadIfConfirm("Ops..", "Houve um problema com a sua solicitação. Clique em OK para atualizar a tela");
                }
              });
          }
        } catch (error) {
          this.isLoading = false;

          console.log(error);

          if (typeof error == "object") {
            if (error.response.status == "403") {
              this.showErrorMessageWithButtonAndReload("Ops...", "Você precisa estar logado para importar lotes.");
            } else {
              this.showErrorMessageWithButtonAndReload("Ops..", "Houve um problema com a sua solicitação. Clique em OK para atualizar a tela");
            }
          } else {
            this.showErrorMessageWithButton("Ops..", error);
          }
        }
      } else {
        this.showErrorMessageWithButton("Ops...", "Selecione um arquivo.");
      }
    },

    logError(msg) {
      this.showErrorMessageWithButton("Ops...", msg);
      this.erros.push(msg);

      document.getElementById("file_select").value = "";
      this.arquivo_lotes_excel = null;
    },

    findLoteByLoteNumero(lote_numero) {
      let indice = this.lotes.findIndex((element) => element["lote_numero"] == lote_numero);

      return indice;
    },

    onChange(e) {
      this.arquivo_lotes_excel = e.target.files[0];
      this.erros = [];
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarDocumentos();
      }
    },

    async buscarCategorias() {
      return axios.post(`/admin/categorias/list`);
    },

    async buscarLotes() {
      console.log("Buscando lotes");

      let data = {
        inicio: 0,
        tamanho: 1000,
        leilao_id: this.leilao.id,
      };

      return axios.post(`/admin/lote/search`, data);
    },

    buscarDocumentos() {
      this.isLoading = true;

      let data = {
        nome: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      axios
        .post(`/admin/documentos/search`, data)
        .then((response) => {
          this.isLoading = false;

          let docs = response.data.documentos;

          docs.sort((a, b) => a.ordem - b.ordem);

          this.documentos = docs;

          //this.documentos = response.data.documentos;

          this.total = response.data.total;

          console.log(this.documentos);

          for (let i = 0; i < this.documentos.length; i++) {
            this.documentos[i].vinculado_leilao = this.isVinculado(this.documentos[i]);
            this.documentos[i].is_edital = this.documentos[i].edital == 1;
          }

          //this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarDocumentos();
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style>
input[type="text"]:disabled {
  background: white;
  border: none;
}

input[type="text"] {
  border-color: black;
}
</style>
